import { AxiosError } from 'axios'
import { useMutation, UseMutationOptions } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { haltsMutationKeys } from 'queries/halts/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

type HaltAllPayload = {
  reason?: string
}

function postHaltAll(queryKey: ReturnType<typeof haltsMutationKeys.haltAll>) {
  return async (payload: HaltAllPayload) => {
    const endpointWithParams = getEndpointWithParams(...queryKey)

    // No response data is expected from this endpoint
    await agent.post(endpointWithParams, payload)
  }
}

export const usePostHalts = (
  options?: Omit<
    UseMutationOptions<undefined, AxiosError, HaltAllPayload>,
    'mutationKey' | 'mutationFn'
  >
) => {
  const { currentTeamId: teamId } = useAuth()

  const mutationKey = haltsMutationKeys.haltAll({ teamId })

  return useMutation({
    ...options,
    mutationFn: postHaltAll(mutationKey),
    mutationKey
  })
}
